module.exports = __webpack_public_path__ + "img/Trophy Cup Table41.84ce500c.jpg";